import { Link } from "react-router-dom";
import type { Product } from "../types";
import { useCartStore } from "../store";

interface ProductCardProps {
	product: Product;
}

export function ProductCard({ product }: ProductCardProps) {
	const addToCart = useCartStore((s) => s.addToCart);

	const handleAdd = (event: React.MouseEvent) => {
		event.preventDefault();
		event.stopPropagation();
		addToCart(product.id, 1);
	};

	return (
		<Link
			to={`/products/${product.id}`}
			data-testid={`product-card-${product.id}`}
			className="group flex flex-col rounded-lg border border-slate-200 bg-white overflow-hidden hover:shadow-md transition-shadow"
		>
			<div
				className="h-40 w-full"
				style={{ backgroundColor: product.imageColor }}
				aria-hidden="true"
			/>
			<div className="p-4 flex flex-col gap-2 flex-1">
				<div className="flex items-start justify-between gap-2">
					<h3 className="font-semibold text-slate-900">{product.name}</h3>
					<span className="text-sm font-medium text-slate-900">
						${product.price}
					</span>
				</div>
				<span className="inline-block text-xs uppercase tracking-wide text-slate-500">
					{product.category}
				</span>
				<div className="mt-auto pt-2">
					<button
						type="button"
						onClick={handleAdd}
						data-testid={`product-card-add-${product.id}`}
						className="btn-primary w-full text-sm"
					>
						Add to cart
					</button>
				</div>
			</div>
		</Link>
	);
}

export default ProductCard;
